var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.94745 13.7538L15.6705 7.03075L14.6167 5.97693L8.94745 11.6462L6.09745 8.79615L5.04362 9.84998L8.94745 13.7538ZM10.3683 19C9.05442 19 7.81938 18.7506 6.66325 18.252C5.5071 17.7533 4.50142 17.0765 3.6462 16.2217C2.79097 15.3669 2.11391 14.3616 1.61502 13.206C1.11614 12.0504 0.866699 10.8156 0.866699 9.50165C0.866699 8.18772 1.11603 6.95268 1.6147 5.79655C2.11337 4.6404 2.79012 3.63472 3.64495 2.7795C4.4998 1.92427 5.50504 1.24721 6.66067 0.748326C7.81629 0.249443 9.05107 0 10.365 0C11.6789 0 12.914 0.249334 14.0701 0.748001C15.2263 1.24667 16.2319 1.92342 17.0872 2.77825C17.9424 3.6331 18.6194 4.63834 19.1183 5.79398C19.6172 6.94959 19.8667 8.18437 19.8667 9.4983C19.8667 10.8122 19.6173 12.0473 19.1187 13.2034C18.62 14.3596 17.9432 15.3652 17.0884 16.2205C16.2336 17.0757 15.2283 17.7527 14.0727 18.2516C12.9171 18.7505 11.6823 19 10.3683 19Z",
    fill: "#E7EF7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.855113fbc4f0538d856cb5ccbccbff01.svg";
export { ForwardRef as ReactComponent };